import { createContext, useContext, useEffect, useState } from "react";
import { translations, LANGS } from "@/i18n/translations";

const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    try {
      const saved = localStorage.getItem("pakla_lang");
      if (saved && translations[saved]) return saved;
    } catch (e) {}
    return "tr";
  });

  useEffect(() => {
    try {
      localStorage.setItem("pakla_lang", lang);
      document.documentElement.setAttribute("lang", lang);
    } catch (e) {}
  }, [lang]);

  const t = translations[lang] || translations.tr;
  return (
    <LangContext.Provider value={{ lang, setLang, t, langs: LANGS }}>
      {children}
    </LangContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error("useLang must be used within LangProvider");
  return ctx;
};
